export const TDocument =  [{
    id: 1,
    departement: 'Direction nationale de la Securité Routière',
    types:["Permis de Conduire","Carte Grise","Autorisation de transport","Certificat de non gage"],
    montant: 50000
  },
  {id:2,
    departement: "Direction nationale de la police des aires et des frontières",
    types:["Carte d'identité nationale","Passport"],
    montant: 50000
  }
]
export const mois = [{
  id:"01",
  month:"Janvier"
},
{
  id:"02",
  month:"Février"
},
{
  id:"03",
  month:"Mars"
},
{
  id:"04",
  month:"Avril"
},
{
  id:"05",
  month:"Mai"
},
{
  id:"06",
  month:"Juin"
},
{
  id:"07",
  month:"Juillet"
},
{
  id:"08",
  month:"Août"
},
{
  id:"09",
  month:"Septembre"
},
{
  id:"10",
  month:"Octobre"
},
{
  id:"11",
  month:"Novembre"
},
{
  id:"12",
  month:"Décembre"
},
]